import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  

  highlight: {
    fontFamily: 'Poppins',
    fontSize: 20,
    textAlign: 'center',
    fontStyle: 'bold',
    fontWeight: 'fontWeightBold',
    color: 'rgba(107, 54, 247, 1)',
  },
  normal1: {
    fontFamily: 'Poppins',
    fontSize: 16,
    color: 'rgba(51, 51, 51, 1)',
  },
  normal2: {
    fontFamily: 'Poppins',
    fontSize: 24,
    color: 'rgba(51, 51, 51, 1)',
        textAlign: 'center',
        fontStyle: 'bold',
        
  },
  image: {
    justifyContent: 'center',
    alignItems: 'center',
        
  }
});